export function flattenFolders(folders, path = [], depth = 1) {
  const result = []

  folders.forEach(folder => {
    result.push({ id: folder.id, path: path.concat(folder.name) })

    const childFolders = folder.child.filter(item => item.type === 'folder')

    if (depth < 5) {
      result.push(
        ...flattenFolders(childFolders, path.concat(folder.name), depth + 1)
      )
    }
  })

  return result
}

export async function getEncodedImage(imageUrl) {
  try {
    const response = await fetch(imageUrl, {
      credentials: 'include'
    })
    const blob = await response.blob()
    const reader = new FileReader()

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const rawCharacters = reader.result.split(',')[1]

        resolve(rawCharacters)
      }

      reader.onerror = () => {
        reject(new Error('Failed to read image'))
      }

      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.error('Error fetching image:', error)
  }

  return null
}
